import { Checkbox } from "@/components/ui/checkbox";
import { ColumnDef as TanStackColumnDef } from "@tanstack/react-table";

export const selectColumn: TanStackColumnDef<any, any> = {
  id: "__select",
  header: ({ table }) => (
    <Checkbox
      checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
      onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      aria-label="Select all"
    />
  ),
  cell: ({ row }) => (
    <span
      onClick={(e) => {
        // Prevent row onClick getting triggered
        e.preventDefault();
        e.stopPropagation();
        row.toggleSelected();
      }}
    >
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => {
          row.toggleSelected(!!value);
        }}
        aria-label="Select row"
        // className="ml-1"
      />
    </span>
  ),
  enableSorting: false,
  enableHiding: false,
  enableResizing: false,
  size: 30,
};
